<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-start">
      <Lynx-Title text="Acompanhamento de Taxas" />

      <Lynx-Button
        text="Atualizar Planilha"
        outlined="true"
        @click.native="fetchtaxasEmpresa"
      />
      <Lynx-Button text="Voltar" outlined="true" @click.native="voltar()" />
    </div>

    <v-card v-if="!loading" elevation="5" class="">
      <div class="p-3">
        <span class="text-xl mb-2">
          Planilha Taxas da empresa:
          {{ empresa.id + " - " + empresa.razao_social }}</span
        >
      </div>

      <div class="w-full">
        <div class="flex justify-center" v-if="loading">
          <Lynx-Spinner size="16" />
        </div>

        <b-table
          :data="loading ? [] : taxas_empresa"
          :columns="columns"
          hoverables
          paginated
          style="font-size: 13px"
          narrowed
          v-else
          default-sort-direction="asc"
          default-sort="id"
          :loading="loading"
          backend-pagination
          @page-change="onPageChange"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
          :total="pagination.total"
          :current-page="pagination.current_page"
          :per-page="pagination.per_page"
          striped
        >
          <template slot-scope="props">
            <b-table-column field="type_document">
              {{ props.row.type_document }}
            </b-table-column>

            <b-table-column field="data_vencimento">
              <Lynx-Input type="date" v-model="props.row.data_vencimento" />
            </b-table-column>
            <b-table-column field="tipo">
              <b-select
                v-model="props.row.tipo_taxa"
                placeholder="selecione uma taxa"
              >
                <option
                  v-for="status in taxasOptions"
                  :key="status.id"
                  :value="status.value"
                  v-text="status.label"
                ></option>
              </b-select>
            </b-table-column>
            <b-table-column field="envio" sortable
              ><Lynx-Input type="date" v-model="props.row.envio"
            /></b-table-column>
            <b-table-column field="pagamento" sortable>
              <b-select v-model="props.row.pagamento" placeholder="Pagamento">
                <option
                  v-for="pg in PagamentoOptions"
                  :key="pg.id"
                  :value="pg.value"
                  v-text="pg.label"
                ></option>
              </b-select>
            </b-table-column>

            <b-table-column style="width: 130px" field="valor" sortable>
              <InputMoney
                required
                v-model="props.row.valor"
                @input="(money) => (props.row.valor = money)"
              ></InputMoney
            ></b-table-column>
            <b-table-column field="acoes" sortable searchable>
              <Lynx-Button
                class="self-start mt-2"
                icon="Save"
                icon-size="3"
                size="small"
                @click.native="editTaxa(props.row)"
              />
              <Lynx-Button
                class="self-start mt-2"
                icon="Eye"
                icon-size="3"
                size="small"
                @click.native="editAlvara(props.row)"
              />
              <Lynx-Button
                v-if="hasRole('super-admin')"
                icon="User"
                color="success-base"
                icon-size="3"
                size="small"
                @click.native="openModelLogs(props.row)"
              />
            </b-table-column>
          </template>
          <template v-slot:empty>
            <NotFoundData text="Nenhum taxa registrada!" />
          </template>
        </b-table>
      </div>
    </v-card>

    <Logs
      v-if="modelLogs"
      :logs="logs"
      :model="modelLogs"
      @update:model="hide()"
    ></Logs>
    <v-dialog
      v-model="editAlvaraModal"
      v-if="editAlvaraModal"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <Alvara-Padrao
      v-if="editAlvaraModal"
        :alvara="documento"
        :empresa-id="empresa.id"
        @edit-alvara="onEditAlvara"
           @fechar-modal="editAlvaraModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import {
  showtaxasEmpresaRequest,
  updateTaxasRequest,
} from "@/services/requests/taxas";
// import EditTaxa from "@/views/empresas/taxasAlvaras/Edit";
// import CreateTaxa from "@/views/empresas/taxasAlvaras/Create";
import NotFoundData from "@/components/layouts/NotFoundData";
import moment from "moment";
import { monthNames, dayNames } from "@/utils/utils";
import { formatEnToBr, formatBrToEn } from "@/utils/momentHelpers";
import Treeselect from "@riophae/vue-treeselect";
import Alvaras from "@/views/empresas/show/Alvaras";
import { mapGetters } from "vuex";
import Logs from "@/views/empresas/alvaras/Logs";
import { hasRole } from "@/utils/can";
import InputMoney from "@/components/helpers/InputMoney";
import AlvaraPadrao from "@/views/empresas/alvaras/AlvaraPadrao";

import { TipoTaxasEnum } from "@/utils/enum";
export default {
  name: "taxasEmpresaIndex",
  components: {
    NotFoundData,
    Treeselect,
    Logs,
    InputMoney,
    AlvaraPadrao,
  },
  data() {
    return {
      filtros: {
        empresa_id: null,
        page: 1,
        perPage: 10,
        type_document: null,
        status: null,
      },
      taxasOptions: TipoTaxasEnum,
      columns: [
        {
          field: "type_document",
          label: "Documento",
          sortable: true,
        },
        {
          field: "data_vencimento",
          label: "Data vencimento",
          sortable: true,
        },
        {
          field: "tipo_taxa",
          label: "Tipo",
          sortable: true,
        },
        {
          field: "envio",
          label: "Envio",
          sortable: true,
        },
        {
          field: "pagamento",
          label: "Pagamento",
          sortable: true,
        },
        {
          field: "valor",
          label: "Valor",
          sortable: true,
        },
        {
          field: "acoes",
          label: "Açoes",
        },
      ],

      PagamentoOptions: [
        {
          label: "selecione",
          value: 0,
        },
        {
          label: "Aguardando Pagamento",
          value: 1,
        },
        {
          label: "Não fez Pagamento",
          value: 2,
        },
        {
          label: "Efetuou o pagamento",
          value: 3,
        },
      ],
      logs: {},
      taxasEmpresa: null,
      loading: false,
      modelLogs: false,

      editAlvaraModal: false,
      documento: false,
    };
  },
  filters: {
    formatEnToBr,
    money: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  computed: {
    ...mapGetters(["getToken"]),

    taxas_empresa() {
      return this.taxasEmpresa.data;
    },
    empresa() {
      return this.taxasEmpresa.empresa;
    },
    pagination() {
      return this.taxasEmpresa.pagination;
    },
  },
  watch: {
    "filtros.perPage"() {
      this.fetchtaxasEmpresa();
    },
    current_page() {
      this.filtros.page = this.current_page;
      this.fetchtaxasEmpresa();
    },
  },
  methods: {
    hasRole,
    getStatus(value) {
      const today = new Date();
      const vencimento = new Date(value.data_vencimento);
      const diffDays = Math.ceil((vencimento - today) / (1000 * 60 * 60 * 24));

      if (
        !value.tipo_document
          ? false
          : value.tipo_document == "alvara"
          ? !value.definitivo
            ? false
            : true
          : false
      ) {
        return "Definitivo";
      }

      if (diffDays <= 0) {
        return "Venc";
      } else if (diffDays <= 45) {
        return "Próx Venc";
      } else {
        return "Normal";
      }
    },
    getStatusClass(taxa) {
      const status = this.getStatus(taxa);

      return status === "Venc"
        ? "bg-error-base text-neutral-100 pl-1 mt-1 rounded"
        : status === "Próx Venc"
        ? "bg-warning-base text-neutral-100 pl-1 mt-1 rounded"
        : status === "Normal"
        ? "bg-success-base text-neutral-100 pl-1 mt-1 rounded"
        : "bg-primary-600 text-neutral-100 pl-1 mt-1 rounded";
    },

    async fetchtaxasEmpresa() {
      this.loading = true;
      this.filtros.empresa_id = this.$route.params.empresa_id;
      const { filtros } = this;
      await showtaxasEmpresaRequest(filtros)
        .then((res) => (this.taxasEmpresa = res.data))

        .finally(() => (this.loading = false));
      this.loading = false;
      console.log(this.taxasEmpresa);
    },
    openCreateModal() {
      this.createModal = true;
    },
    openEditModal(currentEmpAlvs) {
      this.$store.dispatch("setEmpresa", currentEmpAlvs);
      this.currentEmpAlvs = currentEmpAlvs;
      this.editModal = true;
    },
    onEditTaxa() {
      this.fetchtaxasEmpresa();
      this.editModal = false;
    },
    onCreateTaxa() {
      this.fetchtaxasEmpresa();
      this.createModal = false;
    },

    onPageChange(page) {
      this.current_page = page;
    },

    gerarRelatorio() {},
    editarTaxa(empresa_id) {},
    openModelLogs(value) {
      this.modelLogs = true;
      this.logs = value.logs;
    },

    async editTaxa(taxa) {
      await updateTaxasRequest(taxa.id, taxa)
        .then((response) => {
          this.$snack.success(response.data.msg);
        })
        .catch((err) =>
          this.$snack.error(err.response.data.message || this.errorMessage)
        )
        .finally(() => {
          this.loadingButton = false;
          this.removeTaxaHundred(0);
        });
    },
    onEditAlvara() {
      this.editAlvaraModal = false;
      this.fetchtaxasEmpresa();
    },
    editAlvara(taxa) {
      this.editAlvaraModal = true;

      switch (taxa.type_document) {
        case "alvara":
          this.documento = {
            id: taxa.document_id,
            empresa_id: taxa.empresa_id,
            tipoAlvara: "alvara",
          };
          break;
        case "sanitario":
          this.documento = {
            id: taxa.document_id,
            empresa_id: taxa.empresa_id,
            tipoAlvara: "sanitario",
          };
          break;
        case "bombeiro":
          this.documento = {
            id: taxa.document_id,
            empresa_id: taxa.empresa_id,
            tipoAlvara: "bombeiro",
          };
          break;
        case "coworking":
          this.documento = {
            id: taxa.document_id,
            empresa_id: taxa.empresa_id,
            tipoAlvara: "coworking",
          };
          break;
        case "ambiental":
          this.documento = {
            id: taxa.document_id,
            empresa_id: taxa.empresa_id,
            tipoAlvara: "ambiental",
          };
          break;
      }
    },

    voltar() {
      this.$router.push({
        name: "empresas.taxas.index",
      });
    },
  },
  beforeMount() {
    this.fetchtaxasEmpresa();
  },
};
</script>


